export default {"src":"/_next/static/media/recycle_illustration.38d926ce.svg","height":244,"width":300};